<template>
    <v-card
        class="dashboard-card ma-2"
        elevation="0"
    >
        <v-card-title>Reports</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-form
                ref="reportForm"
                v-model="isValid"
            >
                <v-row>
                    <v-col cols="12">
                        <v-select
                            :disabled="isLoading"
                            :items="reportTypes"
                            item-text="name"
                            item-value="value"
                            label="Report Type"
                            v-model="reportType"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row v-show="reportType && (reportType.requireFromToDates == true || reportType.requireLiveOrDateRange == true)">
                    <v-col cols="12">
                                                                                        <v-switch v-show="reportType && reportType.requireLiveOrDateRange == true"
                                            class="mb-0"
                                            label="Live"
                                            v-model="isLive"
                                        ></v-switch>
                    </v-col>
                    <v-col cols="6" v-show="!(reportType && reportType.requireLiveOrDateRange == true && this.isLive == true)">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-right="40"
                            min-width="290px"
                            offset-y
                            transition="scale-transition"
                            v-model="dateMenuFrom"

                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="From"
                                    prepend-icon="mdi-calendar-month"
                                    readonly
                                    v-bind="attrs"
                                    v-model="inputDateFrom"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                @input="dateMenuFrom = false"
                                color="secondary"
                                v-model="inputDateFrom"
                                
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="6" v-show="!(reportType && reportType.requireLiveOrDateRange == true && this.isLive == true)">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-right="40"
                            min-width="290px"
                            offset-y
                            transition="scale-transition"
                            v-model="dateMenuTo"
                            
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="To"
                                    prepend-icon="mdi-calendar-month"
                                    readonly
                                    v-bind="attrs"
                                    v-model="inputDateTo"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                @input="dateMenuTo = false"
                                color="secondary"
                                v-model="inputDateTo"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row v-if="reportType && reportType.requireProviderId == true">
                    <v-col cols="12">
                        <v-select
                            :disabled="isLoading"
                            :items="providers"
                            :rules="[requiredRule]"
                            clearable
                            item-text="value"
                            item-value="key"
                            label="Provider"
                            v-model="providerId"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="isLoading && !isSaving"
                        :loading="isSaving"
                        @click="getReport"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Get</v-btn>
                </v-row>
            </v-form>
        </v-card-text>
        <v-snackbar
            :color="notifyColor"
            :timeout="notifyTimeout"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import fileDownload from "js-file-download";
export default {
    props: ["accessCrud"],
    name: "Reports",
    data: () => ({
        isLoading: null,
        isSaving: null,
        isValid: null,
        inputDateFrom: new Date().toISOString().substr(0, 10),
        inputDateTo: new Date().toISOString().substr(0, 10),
        notifyShow: null,
        notifyMessage: null,
        notifyColor: null,
        notifyTimeout: 15000,

        dateMenuFrom: false,
        dateMenuTo: false,
        providers: [],
        providerId: null,

        isLive: true,

        reportTypes: [],
        reportType: null, // this.reportTypes[0],
        requiredRule: v => !!v || "required"
        //
    }),
    created: function() {
        this.reportTypes = [
            {
                name: "Patient List",
                entity: "Report",
                value: {
                    access: "patientList",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accepted Log",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "acceptedLog",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Incident Exceptions",
                entity: "Report",
                value: {
                    access: "incidentException",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Patient Exceptions",
                entity: "Report",
                value: {
                    access: "patientException",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Account Exceptions",
                entity: "Report",
                value: {
                    access: "accountException",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Claim Exceptions",
                entity: "Report",
                value: {
                    access: "claimException",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, New Registrations",
                entity: "Report",
                value: {
                    access: "newaccountregistrationsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Verified",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "verifiedaccountsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Queried",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "queriedaccountsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Accepted",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "acceptedaccountsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Rejected",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "rejectedaccountsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Processed",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "processedaccountsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Partly Accepted",
                entity: "Report",
                value: {
                    access: "partlyacceptedaccountsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Incidents, Ar Suspended",
                entity: "Report",
                value: {
                    access: "arsuspendedincidentsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Incidents, Late Registration Suspended",
                entity: "Report",
                value: {
                    access: "lateregistrationsuspendedincidentsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Patients, Missing Documents Suspended",
                entity: "Report",
                value: {
                    access: "missingdocumentssuspendedpatientsreport",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Queried PDF",
                entity: "Report",
                value: {
                    access: "queriedaccountspdfreport",
                    requireFromToDates: false,
                    requireLiveOrDateRange: true,
                    requireProviderId: true
                }
            },
            {
                name: "Accounts, Rejected PDF",
                entity: "Report",
                value: {
                    access: "rejectedaccountspdfreport",
                    requireFromToDates: false,
                    requireLiveOrDateRange: true,
                    requireProviderId: true
                }
            },
            {
                name: "Accounts, Accepted PDF",
                entity: "Report",
                value: {
                    access: "acceptedaccountspdfreport",
                    requireFromToDates: false,
                    requireLiveOrDateRange: true,
                    requireProviderId: true
                }
            },
            {
                name: "Accounts, Paid PDF",
                entity: "Report",
                value: {
                    access: "paidaccountspdfreport",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: true
                }
            },
            {
                name: "Accounts, Partly Accepted PDF",
                entity: "Report",
                value: {
                    access: "partlyacceptedaccountspdfreport",
                    requireFromToDates: false,
                    requireLiveOrDateRange: true,
                    requireProviderId: true
                }
            },
            {   
                name: "Accounts, New PDF",
                entity: "Report",
                value: {
                    access: "newaccountspdfreport",
                    requireFromToDates: false,
                    requireLiveOrDateRange: true,
                    requireProviderId: true
                }
            },
            {
                name: "Accounts, Summary PDF",
                entity: "ReportAccountsStatus",
                value: {
                    access: "accountsstatusreport",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: true
                }
            },
            {
                name: "Accounts, Rejected Live",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "rejectedaccountsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Accepted Live",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "acceptedaccountsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Partly Accepted Live",
                entity: "Report",
                value: {
                    access: "partlyacceptedaccountsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Verified Live",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "verifiedaccountsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Queried Live",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "queriedaccountsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, Processed Live",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "processedaccountsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Accounts, New Live",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "newaccountsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Claims, Accepted Not Yet Submitted Live",
                entity: "Report",
                value: {
                    access: "acceptednotyetsubmittedclaimsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },

            {
                name: "Provider Report",
                entity: "ProviderReport",
                value: {
                    access: "providerReport",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Transaction Log",
                entity: "TransactionLog",
                value: {
                    access: "transactionLog",
                    requireFromToDates: true,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },

            
        ]
            .filter(x => {
                return this.accessCrud.some(y => {
                    return x.entity == y.e && y.c == true;
                });
            })
            .sort(function(a, b) {
                return a.name > b.name ? 1 : -1;
            });
        this.areAnyReportsAvailable(this.reportTypes.length > 0);
    },
    mounted: async function() {
        if (this.reportTypes.length > 0)
            this.reportType = this.reportTypes[0].value;
        //
        this.providers = await this.$store.dispatch("providers/getlist");
    },
    components: {
        //
    },
    methods: {
        areAnyReportsAvailable(areAnyReportsAvailable) {
            this.$emit("reports", areAnyReportsAvailable);
        },
        notify(message, color, timeout) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
            this.notifyTimeout =
                typeof timeout === "undefined" ? 15000 : timeout;
        },
        validateForm() {
            this.isValid = this.$refs.reportForm.validate();
            return this.isValid;
        },
        getReport() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;
                var params = {};

                if (this.reportType.requireFromToDates == true) {
                    params.fromDate = this.inputDateFrom;
                    params.toDate = this.inputDateTo;
                }

                if (this.reportType.requireLiveOrDateRange == true) {
                    params.live = this.isLive;
                    if(this.isLive == false)
                    {
                    params.fromDate = this.inputDateFrom;
                    params.toDate = this.inputDateTo;
                    }
                }

                if (this.reportType.requireProviderId == true) {
                    params.providerId = this.providerId;
                }

                this.$store
                    .dispatch("reports/" + this.reportType.access, params)
                    .then(
                        response => {
                            this.notify("Downloading...", "success", 3000);
                            fileDownload(
                                response.data,
                                response.headers["content-disposition"].match(
                                    /filename\s*=\s*(.+);/i
                                )[1]
                            );
                        },
                        error =>
                            error.response.data
                                .text()
                                .then(text => this.notify(text, "error"))
                    )
                    .finally(this.getReportDone);
            }
        },
        getReportDone() {
            this.isLoading = false;
            this.isSaving = false;
        }
        //
    },
    destroyed: function() {}
};
</script>

<style lang="stylus" scoped></style>